import { ADDTIMESHEET_DETAILS, APPROVE_TIMESHEET, BULK_APPROVE_TIMESHEET, CLEAR_TIMESHEET, EDITTIMESHEET_DETAILS, PENDING_TIMESHEET, SENDBACK_TIMESHEET, TIMESHEET_LIST, USER_TIMESHEET_LIST } from "./ActionType";


const initialValue = {
    timesheetlist: [],
    usertimesheetlist: [],
    addTimesheet: null,
    editTimesheet: {},
    pendingTimesheetList: [],
    bulkapprovetimesheet: [],
    approvetimesheet: null,
    sendbacktimesheet: null,
}

export const timeSheetReducer = (store = initialValue, { type, payload }) => {

    if (type === TIMESHEET_LIST) {
        return {
            ...store, timesheetlist: payload.pendingList || [],
        };
    } else if (type === USER_TIMESHEET_LIST) {
        return {
            ...store, usertimesheetlist: payload || [],
        };
    } else if (type === ADDTIMESHEET_DETAILS) {
        return {
            ...store, addTimesheet: payload,
        };
    } else if (type === EDITTIMESHEET_DETAILS) {
        return {
            ...store, editTimesheet: payload.pendingList,
        };
    } else if (type === CLEAR_TIMESHEET) {
        return {
            ...store, editTimesheet: {},
        };
    } else if (type === PENDING_TIMESHEET) {
        return {
            ...store, pendingTimesheetList: payload || [],
        };
    } else if (type === APPROVE_TIMESHEET) {
        return {
            ...store, approvetimesheet: payload,
        };
    } else if (type === SENDBACK_TIMESHEET) {
        return {
            ...store, sendbacktimesheet: payload,
        };
    } else if (type === BULK_APPROVE_TIMESHEET) {
        return {
            ...store, bulkapprovetimesheet: payload.userList || [],
        };
    }

    return store
}
